/**
 * Ears. POSTs 16 kHz linear16 PCM to hottie-listen (Flux STT).
 * DEEPGRAM_API_KEY never leaves the edge function.
 */

import { env } from '@/config/env';

export async function listenUtterance(
  pcm: ArrayBuffer,
  accessToken: string,
): Promise<{ ok: true; transcript: string } | { ok: false; error: string }> {
  if (!pcm.byteLength) return { ok: false, error: "couldn't hear that" };
  if (!env.supabaseUrl || !env.supabaseAnonKey) {
    return { ok: false, error: "couldn't hear that" };
  }

  let res: Response;
  try {
    res = await fetch(`${env.supabaseUrl}/functions/v1/hottie-listen`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        apikey: env.supabaseAnonKey,
        'Content-Type': 'application/octet-stream',
      },
      body: pcm,
    });
  } catch {
    return { ok: false, error: "couldn't hear that" };
  }

  if (!res.ok) return { ok: false, error: "couldn't hear that" };

  try {
    const data = (await res.json()) as { transcript?: unknown };
    const transcript = typeof data.transcript === 'string' ? data.transcript.trim() : '';
    if (!transcript) return { ok: false, error: "couldn't hear that" };
    return { ok: true, transcript };
  } catch {
    return { ok: false, error: "couldn't hear that" };
  }
}
